module.exports = __webpack_public_path__ + "media/images/hezbollah-bg-map-11f80719ff71ce1585753cbe57afc5fd.svg";